module.exports = __webpack_public_path__ + "img/KRIM.6e3f2a0b.png";